import { Box, Typography, styled } from '@mui/material'

export const StyledWidgetGlobalPrice = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
  position: 'relative',
  height: '100%',
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'row',
    gap: theme.spacing(2),
    justifyContent: 'center',
  },
  [theme.breakpoints.up('sm')]: {
    padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
  },
}))

export const IconContainer = styled(Box)(({ theme }) => ({
  fontSize: '48px',
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(2),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: '32px',
    marginBottom: 0,
    flexShrink: 0,
  },
}))

export const Label = styled(Typography)(() => ({
  color: '#888888',
  fontWeight: 400,
  fontSize: '12px'
}))

export const NumberContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'end',
  lineHeight: '34px',
  justifyContent: 'start',
}))

export const Number = styled(Typography)(({ theme }) => ({
  color: theme.palette.content.primary,
  fontWeight: 600,
  fontSize: '24px'
}))

export const NumberIcon = styled(Box)(({ theme }) => ({
  fontSize: '18px',
  marginLeft: theme.spacing(1),
  fontWeight: '500',
  color: '#888888'
}))
